import { useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../../store/slices/userSlice";
import { NavLink } from "react-router-dom";
import { Twirl as HamburgerIcon } from "hamburger-react";

import { ReactComponent as Stock_icon } from "../../../style/img/stock_icon.svg";
import { ReactComponent as Catalogue_icon } from "../../../style/img/catalogue_icon.svg";
import { ReactComponent as Counterparty_icon } from "../../../style/img/counterparty_icon.svg";
import { ReactComponent as Users_icon } from "../../../style/img/users_icon.svg";
import { ReactComponent as Payment_icon } from "../../../style/img/payment_icon.svg";
import { ReactComponent as Purchase_icon } from "../../../style/img/purchase_icon.svg";
import { ReactComponent as Sell_icon } from "../../../style/img/sell_icon.svg";
import { ReactComponent as Setting_icon } from "../../../style/img/setting.svg";

import exit_icon from "../../../style/img/exit.png";
import "./asideBarNav.css";

const menuItems = [
  // {
  //   label: "Журнал",
  //   icon: <Log_icon />,
  //   to: "/",
  // },
  {
    label: "Каталог",
    icon: <Catalogue_icon />,
    to: "/catalogue",
  },

  {
    label: "Склад",
    icon: <Stock_icon />,
    to: "/stock",
  },
  {
    label: "Контрагенти",
    icon: <Counterparty_icon />,
    to: "/counterparty",
  },
  {
    label: "Користувачі",
    icon: <Users_icon />,
    to: "/users",
  },
  {
    label: "Каса",
    icon: <Payment_icon />,
    to: "/payment",
  },
  {
    label: "Закупівля",
    icon: <Purchase_icon />,
    to: "/purchase",
  },
  {
    label: "Продажі",
    icon: <Sell_icon />,
    to: "/sell",
  },
  {
    label: "Опції",
    icon: <Setting_icon />,
    to: "/setting",
  },
];

const AsideBarNav = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const toggleOpen = () => {
    setOpen(!open);
  };

  const renderMenuItem = (menuItem) => {
    return (
      <NavLink key={menuItem.to} className="sideitem" to={`${menuItem.to}`}>
        <div className="sideitem_svg_wrapper">{menuItem.icon}</div>

        <span className="linkText">{menuItem.label}</span>
      </NavLink>
    );
  };
  return (
    <div className={open ? "sidenav" : "sidenavClosed"}>
      <div>
        <button className="menuBtn" onClick={toggleOpen}>
          <HamburgerIcon size={30} toggled={open} toggle={setOpen} />
        </button>

        <nav className="navbar">
          {menuItems.map((menuItem) => renderMenuItem(menuItem))}
        </nav>
      </div>
      <div className="sideitem" onClick={() => dispatch(logout())}>
        <div>
          <img className="exit_icon_nav" src={exit_icon} alt="exit" />
        </div>

        <span className="linkText sideitem_exitSpan">Вихід</span>
      </div>
    </div>
  );
  // return <nav className='navbar'>{menuItems.map((menuItem) => renderMenuItem(menuItem))}</nav>;
};

export default AsideBarNav;
